import React, { useState, useEffect } from 'react';
import apiClient from '../utils/apiClient';
import Select from 'react-select';
import { SERVER_BASE } from '../config/server';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import {hasPermission} from "../utils/usePermissions";
import { useNavigate, useLocation } from "react-router-dom";
const AddInventoryLedger = ({ accessOfDepartments, accessedLedgers }) => {
  const [isFormVisible, setIsFormVisible] = useState(false); // 'add' or 'less'
  const [header, setHeader] = useState({
    date: '',
    purpose: null,
    transaction: null,
    remarks: '',
    ledgerName: '',
    ledgerId: '',
    approved:null,
    approvalNumber:''
  });
  const [inventory, setInventory] = useState([
    { item: null, quantity: '', location: null, state: null, itemCode: '', uom: '', unit: '' },
  ]);
  const code = localStorage.getItem('code');
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const email = localStorage.getItem('email'); // Retrieve email from localStorage
  const role = localStorage.getItem('role'); // Retrieve email from localStorage
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const [purposes, setPurposes] = useState([]);
  const [locations, setLocations] = useState([]); // Location data
  const token = localStorage.getItem('token');
 
  const navigate = useNavigate();
  const location = useLocation();
  const rowId = location.state?.rowId
  const [departments, setDepartments] = useState([]);
  const [selectedDept, setSelectedDept] = useState(null);
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const transactionOptions = [
    { value: "Regular", label: "Regular" },
    { value: "Visit", label: "Visit" },
    { value: "AHQ", label: "AHQ" },
  ];
  const [itemOptions, setItemOptions] = useState([]); // State for item options
  const fetchDraftData = async () => {
    if (rowId) {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getDraftById/${rowId}`);
        const data = response.data;

        setHeader({
          date: data.date ?? '',
          purpose: data.purpose ? { value: data.purpose, label: data.purpose } : null,
          transaction: data.transaction ? { value: data.transaction, label: data.transaction } : null,
          remarks: data.remarks ?? '',
          ledgerName: data.ledgerName || null,
          ledgerId: data?.ledgerId,
        });
        setSelectedDept({ value: data.department, label: data.department })
        setInventory(
          data.inventory?.map(item => ({
            item: {
              value: item.item, label: item.item, itemCode: item.itemCode,
              uom: item.uom,
              unit: item.unit, itemId: item.itemId
            } ?? null,
            quantity: item.quantity ?? '',
            location: { value: item.location, label: item.location } ?? null,
            state: { value: item.state, label: item.state } ?? null,
            itemCode: item.itemCode ?? '',
            uom: item.uom ?? '',
            unit: item.unit ?? ''
          })) || []
        );

      } catch (err) {
        console.error(err.response?.data?.message || 'Error fetching draft data');
      }
    }
  };

  useEffect(() => {
    fetchDraftData();
  }, [rowId]);
  useEffect(() => {
    fetchItemOptions(accessOfDepartments);
  }, []);
  const fetchItemOptions = async (accessOfDepartments) => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/get-items-approved`, {
        params: {
          centerCode: code,
          accessOfDepartments
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Set the combined data in the state
      setItemOptions(response.data.map((item) => ({
        value: item.printName,
        itemId: item.id,
        label: `${item.printName} ${item.additionalNames ? ` - [ ${item.additionalNames} ]` : ''}`,
        itemCode: item.itemCode,
        uom: item.uom,
        unit: item.unit,
      })));
    } catch (error) {
      console.error('Error fetching or merging item data:', error.message);
      console.error('Details:', error.response?.data || error.message);
    }
  };
  useEffect(() => {
    const fetchledgermasterdetails = async () => {      
      try {
        const response = await apiClient.get(SERVER_BASE + '/ledgerMastersMainTain', {
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });
    
        // Convert accessedLedgers (string like "45,54,58,89") into an array of numbers
        const accessedLedgerIds = accessedLedgers
          .split(',')
          .map((id) => parseInt(id.trim()));
    
        // Filter ledgers that are in accessedLedgers
        const filteredLedgers = response.data.filter((ledger) =>
          accessedLedgerIds.includes(ledger.id)
        );
    
        // Prepare options for dropdown
        const options = filteredLedgers.map((ledger) => ({
          value: ledger.printName,
          label: ledger.printName,
          ledgerId: ledger.id,
          group: ledger.ledgerGroup,
          address: ledger.address,
          gstin: ledger.gstin,
        }));
    
        setLedgerOptions(options);
      } catch (error) {
        console.error('Error fetching ledger master details:', error);
      }
    };    
    const fetchProfileDetails = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email, role } });
        setProfileDetails(response?.data[0] || null);
        // Assume the first row contains the profile data
      } catch (err) {
        console.error('Error fetching profile details:', err);
        setProfileDetails(null);
      }
    };
    fetchProfileDetails();
    fetchledgermasterdetails();
  }, [code, email]);
  useEffect(() => {
    if (accessOfDepartments) {
      const deptArray = accessOfDepartments
        .split(',')
        .map((dept) => ({ value: dept.trim(), label: dept.trim() }));
      setDepartments(deptArray);
    }
  }, [accessOfDepartments]);


  const stateOptions = [
    { value: 'As Stock', label: 'As Stock' },
    { value: 'Installed/Fitted with Structure', label: 'Installed/Fitted with Structure' },
    { value: 'Installed/Fitted with Machinery', label: 'Installed/Fitted with Machinery' },
    { value: 'Installed/Fitted with Construction', label: 'Installed/Fitted with Construction' },
    { value: 'Installed/Fitted underground', label: 'Installed/Fitted underground' },
    { value: 'Installed/Fitted above roof', label: 'Installed/Fitted above roof' },
    { value: 'Installed/Fitted under shed', label: 'Installed/Fitted under shed' },
    { value: 'Installed/Fitted above shed', label: 'Installed/Fitted above shed' },
    { value: 'Dormant Stock', label: 'Dormant Stock' },
    { value: 'Office Inventory', label: 'Office Inventory' },
    { value: 'As Condemnation Stock', label: 'As Condemnation Stock' },
  ];
  useEffect(() => {
    fetchPurposes();
    fetchLocations();
  }, []);

  const fetchPurposes = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getpurposesInventoryByApplicability`, {
        params: { code, applicableOn:'Only Area Jurisdiction' }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }, // Pass 'code' as a parameter in the request
      });
      setPurposes(
        response.data
          .filter((purpose) => purpose.purposeType !== 'Less') // Filter out 'less'
          .map((purpose) => ({
            value: purpose.purposeName,
            label: purpose.purposeName,
            type: purpose.purposeType,
          }))
      );
    } catch (error) {
      console.error('Error fetching purposes:', error);
    }
  };
  const fetchLocations = () => {
    apiClient
      .get(SERVER_BASE + "/getLocations", {
        params: { code }, headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        }
      })
      .then((response) =>
        setLocations(
          response.data.map((location) => ({
            value: location.location,
            label: location.location,
          }))
        )
      )
      .catch((error) => console.error(error));
  };

  const fetchAvailableQuantity = async (item, status) => {
    
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getAvailableQuantityLedger`, {
        params: { item, status, code, ledger: header?.ledgerId },
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data.availableQuantity || 0; // Assume the backend returns the available quantity.
    } catch (error) {
      console.error('Error fetching available quantity:', error);
      return 0; // Default to 0 if there’s an error.
    }
  };


  const handleItemChange = async (selected, index) => {
    const selectedItem = itemOptions.find(option => option.value === selected.value);
    const selectedStatus = inventory[index].state?.value;
    const selectedQuantity = inventory[index].quantity;

    // Fetch available quantity using itemCode, location, and status
    const availableQuantity = await fetchAvailableQuantity(selectedItem.itemId, selectedStatus);

    setInventory(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        item: selectedItem,
        itemCode: selectedItem?.itemCode || '',
        uom: selectedItem?.uom || '',
        unit: selectedItem?.unit || '',
        availableQuantity: availableQuantity, // Set the available quantity here
        clBal: availableQuantity + selectedQuantity
      };
      return updated;
    });
  };


  const handleLocationChange = async (selected, index) => {
    const updatedInventory = [...inventory];
    updatedInventory[index].location = selected;

    const selectedItem = updatedInventory[index].item;
    const selectedStatus = updatedInventory[index].state?.value;
    const selectedQuantity = inventory[index].quantity;

    // Fetch available quantity using itemCode, location, and status
    const availableQuantity = await fetchAvailableQuantity(selectedItem?.itemId, selected?.value, selectedStatus);

    updatedInventory[index].availableQuantity = availableQuantity; // Update quantity field with fetched value
    updatedInventory[index].clBal = availableQuantity + selectedQuantity
    setInventory(updatedInventory);
  };

  const handleStateChange = async (selected, index) => {
    const updatedInventory = [...inventory];
    updatedInventory[index].state = selected;

    const selectedItem = updatedInventory[index].item;
    const selectedQuantity = inventory[index].quantity;

    // Fetch available quantity using itemCode, location, and status
    const availableQuantity = await fetchAvailableQuantity(selectedItem?.itemId, selected?.value);

    updatedInventory[index].availableQuantity = availableQuantity; // Update quantity field with fetched value
    updatedInventory[index].clBal = availableQuantity + selectedQuantity
    setInventory(updatedInventory);
  };

  const handleAddRow = () => {
    setInventory((prev) => [
      ...prev,
      { item: null, quantity: '', location: null, state: null, itemCode: '', uom: '', unit: '' },
    ]);
  };

  const handleRemoveRow = (index) => {
    setInventory((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if date is filled
    if (!header.date) {
      Swal.fire({
        icon: 'error',
        title: 'Please select a date.',
        toast: true,
        position: 'top-end',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    if (!header.ledgerName) {
      Swal.fire({
        icon: 'error',
        title: 'Please select Ledger.',
        toast: true,
        position: 'top-end',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }
    // Check if purpose is selected
    if (!header.purpose) {
      Swal.fire({
        icon: 'error',
        title: 'Please select a event.',
        toast: true,
        position: 'top-end',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    // Check if transaction is selected
    if (!header.transaction) {
      Swal.fire({
        icon: 'error',
        title: 'Please select a transaction.',
        toast: true,
        position: 'top-end',
        timer: 2000,
        showConfirmButton: false,
      });
      return;
    }

    // Additional validation for Ledger Name when the purpose is 'Receipt Note'


    // Check each inventory row for missing fields
    for (let i = 0; i < inventory.length; i++) {
      const row = inventory[i];

      if (!row.item) {
        Swal.fire({
          icon: 'error',
          title: `Item is missing in row ${i + 1}.`,
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      if (!row.quantity) {
        Swal.fire({
          icon: 'error',
          title: `Quantity is missing in row ${i + 1}.`,
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      if (!row.state) {
        Swal.fire({
          icon: 'error',
          title: `State is missing in row ${i + 1}.`,
          toast: true,
          position: 'top-end',
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }
    }

    try {
      const payload = {
        date: header.date,
        purpose: header.purpose?.value || header.purpose, // Extract `value` if object
        transaction: header.transaction?.value || header.transaction, // Match backend field
        remarks: header?.remarks,
        type: 'add',
        ledgerName: header.ledgerName || '',
        ledgerId: header.ledgerId || "",
        code,
        createdBy: name,
        createdByBadge: badgeId,
        department: selectedDept?.value,
        inventory_data: inventory.map((item) => ({
          item: item.item?.value || item.item,
          itemId: item.item?.itemId,
          quantity: parseInt(item.quantity, 10), // Ensure quantity is numeric
          state: item.state?.value || item.state, // Extract `value` if object+
          unit: item.unit || '',
          itemCode: item.itemCode || '',
          uom: item.uom || '',
        })),
      };
  
      if (rowId) {
        // Update existing draft
        await apiClient.put(`${SERVER_BASE}/updateInventoryDraftLedger/${rowId}`, payload, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire({
          icon: 'success',
          title: 'Updated!',
          text: 'Draft updated successfully.',
          position: 'top-end',
          toast: true,
          timer: 2000,
          showConfirmButton: false,
        }).then(() => navigate('../AdditionsLedger'));
      } else {
        // Create new draft
        await apiClient.post(`${SERVER_BASE}/addInventoryDraftLedger`, payload, {
          headers: { Authorization: `Bearer ${token}` }
      });
      Swal.fire({
        icon: 'success',
        title: 'Created!',
        text: 'Draft saved successfully.',
        position: 'top-end',
        toast: true,
        timer: 2000,
        showConfirmButton: false,
        }).then(() => navigate('../AdditionsLedger'));
      }
  
      // Reset form
      setHeader({
        date: '',
        purpose: null,
        transaction: null,
        remarks: '',
        ledgerName: null,
        consumptionType: null,
        allocation: null
      });
      setInventory([{ item: null, quantity: '', location: null, state: null, itemCode: '', uom: '', unit: '' }]);
  
    } catch (error) {
      console.error('Error submitting draft:', error);
      Swal.fire({
        icon: 'error',
        title: 'Submission failed',
        text: error.response?.data?.message || error.message,
        toast: true,
        position: 'top-end',
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  return (
    <div className="container mt-5">
      <h3 className="mb-3">Add Inventory Ledger</h3>
        <>
          <button
            className="btn btn-secondary btn-sm me-3 mb-2"
            onClick={() => navigate('../AdditionsLedger')}
          >
            <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
          </button>

          <form onSubmit={handleSubmit} className=''>
            <div className="row mb-3 formcontainer">
              <div className="col-md-3">
                <label htmlFor="date" className="form-label">Date</label>
                <input
                  type="date"
                  id="date"
                  className={`form-control ${!header.date ? "border border-danger" : ""}`}
                  value={header.date}
                  onChange={(e) => setHeader({ ...header, date: e.target.value })}
                />
              </div>
              <div className="col-md-9">
                  <label htmlFor="ledgerName" className="">Ledger Name</label>
                  <Select
                    options={ledgerOptions}
                    value={ledgerOptions.find(option => option.value == header.ledgerName) || null}
                    onChange={(option) =>
                      setHeader({ ...header, ledgerName: option ? option.value : "", ledgerId: option ? option.ledgerId : "" })
                    }
                    isClearable
                  />
                </div>

              <div className="col-md-6">
                <label htmlFor="purpose" className="form-label">Event</label>
                <Select
                  id="purpose"
                  options={purposes}
                  value={header.purpose}
                  onChange={(selected) => setHeader({ ...header, purpose: selected })}
                  isClearable
                  className={!header.purpose ? "border border-danger rounded" : ""}
                />
              </div>
{header.purpose?.value === "Donation / Sewa" && (
  <>
    <div className="col-md-3">
      <label className="form-label">Approved By Beas</label>
      <Select
        options={[
          { label: "Yes", value: "Yes" },
          { label: "No", value: "No" },
        ]}
        value={
          header.approved
            ? { label: header.approved, value: header.approved }
            : null
        }
        onChange={(option) =>
          setHeader({
            ...header,
            approved: option ? option.value : "",
            approvalNumber: option?.value === "No" ? "" : header.approvalNumber,
          })
        }
        isClearable
        className={!header.approved ? "border border-danger rounded" : ""}
      />
    </div>

    {/* Show Approval Number only if Approved = Yes */}
    {header.approved === "Yes" && (
      <div className="col-md-3">
        <label className="form-label">Approval Number</label>
        <input
          type="text"
          className={`form-control ${
            !header.approvalNumber ? "border border-danger" : ""
          }`}
          value={header.approvalNumber || ""}
          onChange={(e) =>
            setHeader({ ...header, approvalNumber: e.target.value })
          }
        />
      </div>
    )}
  </>
)}
              <div className="col-md-3">
                <label htmlFor="transaction" className="form-label">Transaction</label>
                <Select
                  id="transaction"
                  options={transactionOptions}
                  value={header.transaction}
                  onChange={(selected) => setHeader({ ...header, transaction: selected })}
                  isClearable
                  className={!header.transaction ? "border border-danger rounded" : ""}
                />
              </div>

              <div className="col-md-3">
                <label htmlFor="remarks" className="form-label">Remarks</label>
                <input
                  type="text"
                  id="remarks"
                  className="form-control"
                  value={header.remarks}
                  onChange={(e) => setHeader({ ...header, remarks: e.target.value })}
                />
              </div>

              {/* Conditionally render Ledger Name if Purpose is Receipt Note */}

            </div>


            {/* Inventory Section */}
            <div className='formcontainer'>
              <div className="row">
                <div className="col-md-4"><label className="form-label">Item</label></div>
                {/* <div className="col-md-2"><label className="form-label">Location</label></div> */}
                <div className="col-md-3"><label className="form-label">Status</label></div>
                <div className="col-md-1"><label className="form-label">Available</label></div>
                <div className="col-md-1"><label className="form-label">Addition</label></div>
                <div className="col-md-1"><label className="form-label">Cl. Bal</label></div>
                <div className="col-md-1"><label className="form-label">UOM</label></div>
                <div className="col-md-1"></div>
              </div>

              {inventory.map((data, index) => (
                <div className="row mb-2" key={index}>
                  <div className="col-md-4">
                    <Select
                      id={`item-${index}`}
                      options={itemOptions}
                      value={data?.item}
                      onChange={(selected) => handleItemChange(selected, index)}
                    />
                  </div>
                  {/* <div className="col-md-2">
                    <Select
                      id={`location-${index}`}
                      options={locations}
                      value={data?.location}
                      onChange={(selected) => handleLocationChange(selected, index)}
                    />
                  </div> */}
                  <div className="col-md-3">
                    <Select
                      id={`state-${index}`}
                      options={stateOptions}
                      value={data?.state}
                      onChange={(selected) => handleStateChange(selected, index)}
                    />
                  </div>
                  <div className="col-md-1">
                    <input
                      type="number"
                      className="form-control"
                      value={data?.availableQuantity}
                      disabled
                    />
                  </div>
                  <div className="col-md-1">
                    <input
                      type="number"
                      className="form-control"
                      value={data?.quantity}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (Number(value) < 0) return;
                        setInventory((prev) => {
                          const updated = [...prev];
                          updated[index].quantity = value;

                          const qty = Number(value || 0);
                          const available = Number(updated[index].availableQuantity || 0);
                          updated[index].clBal = qty + available;

                          return updated;
                        });
                      }}
                      min="0"
                    />

                  </div>
                  <div className="col-md-1">
                    <input
                      type="number"
                      className="form-control"
                      value={data?.clBal}
                      disabled
                    />
                  </div>
                  <div className="col-md-1">
                    <input
                      type="text"
                      className="form-control"
                      value={data?.item?.uom}
                      disabled
                    />
                  </div>
                  <div className="col-md-1 d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-success btn-sm"
                      onClick={handleAddRow}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </button>
                    {inventory.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger ms-2 btn-sm"
                        onClick={() => handleRemoveRow(index)}
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>
                    )}
                  </div>
                </div>
              ))}
              <button type="submit" className="btn btn-success">Submit</button>
            </div>
          </form>
        </>
    </div>
  );
};

export default AddInventoryLedger;
